import { SignalConfig } from "./SignalConfig";

export class InsetBaySetting
{
    public count;
    //public drop;
    public length_1;
    public length_2;
    //public overhang;

    constructor(config: any)
    {
        this.count    = this.createSignalConfig(config.count);
        //this.drop     = this.createSignalConfig(config.drop);
        this.length_1 = this.createSignalConfig(config.length);
        this.length_2 = this.createSignalConfig(config.length);
        //this.overhang = this.createSignalConfig(config.overhang);
    }

    private createSignalConfig(config)
    {

        var signalConfig = new SignalConfig<number>({
            min: config.min,
            max: config.max,
            value: config.value
        });

        return signalConfig;
    }
}